export const SUPPORT_URL = 'https://fr.ulule.com/on-croit-qu-on-joue-----bien-plus-qu-un-reve-de-football/';
